import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WORKFLOW_QUEUES_REQUEST = 'GET_WORKFLOW_QUEUES_REQUEST';
export const GET_WORKFLOW_QUEUES_SUCCESS = 'GET_WORKFLOW_QUEUES_SUCCESS';
export const GET_WORKFLOW_QUEUES_FAILURE = 'GET_WORKFLOW_QUEUES_FAILURE';

function request() {
  return {
    type: GET_WORKFLOW_QUEUES_REQUEST,
  };
}

function receive(userQueue, initialReviewQueue, secondaryReviewQueue, expertReviewQueue) {
  return {
    type: GET_WORKFLOW_QUEUES_SUCCESS,
    userQueue,
    initialReviewQueue,
    secondaryReviewQueue,
    expertReviewQueue
  };
}

function reject(error) {
  return {
    type: GET_WORKFLOW_QUEUES_FAILURE,
  };
}

export function getWorkflowQueues(workflow, pageNumber, pageSize) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getWorkflowQueues(workflow, pageNumber, pageSize)
      .then((response) => {
        let userQueue = null;
        let initialReviewQueue = null;
        let secondaryReviewQueue = null;
        let expertReviewQueue = null;

        if (response.data) {
          userQueue = response.data.myWork;

          if (response.data.queues) {
            for (let i = 0; i < response.data.queues; i += 1) {
              switch (response.data.queues[i].stage) {
                case 'pendingreview':
                  initialReviewQueue = response.data.queues[i];
                  break;
                case 'pendingsecondaryreview':
                  secondaryReviewQueue = response.data.queues[i];
                  break;
                case 'pendingexpertreview':
                  expertReviewQueue = response.data.queues[i];
                  break;
                default:
                  break;
              }
            }
          }

          initialReviewQueue = response.data.PendingInitialReview;
          secondaryReviewQueue = response.data.PendingSecondaryReview;
          expertReviewQueue = response.data.PendingExpertReview;
        }

        dispatch(receive(userQueue, initialReviewQueue, secondaryReviewQueue, expertReviewQueue));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
